import { HttpRequestBuilder } from "./http/HttpRequestBuilder";

export const getSessionToken = function() {
    let params = new URL(document.location.href).searchParams;
    return params.get("sessionToken"); 
};

export const isDocs = function() {
    let params = new URL(document.location.href).searchParams;
    return (params.get("docs") == "true"); 
};

export const isSettings = function() {
    let params = new URL(document.location.href).searchParams;
    return (params.get("settings") == "true"); 
};

export const getClientID = function() {
    if(document.location.href.includes("prod")) {
        return "06d321b5895730f75762b2b2ff78efaa";
    } else {
        return "9e7cf37654441b5ac82588fed22018fa";
    }
};

const URL_BASE = document.location.origin;
export const URL_SETTINGS = URL_BASE + "/monday/bb/v1/config/settings";
export const URL_BACKUPS = URL_BASE + "/monday/bb/v1/config/backup/";
export const URL_VALIDATE_TOKEN = URL_BASE + "/monday/bb/v1/config/validateToken";
export const URL_QUERY_SESSION_TOKEN = "?sessionToken=" + getSessionToken();

export const validateToken = async function() {
    await new HttpRequestBuilder()
        .method('post')
        .url(URL_VALIDATE_TOKEN + URL_QUERY_SESSION_TOKEN)
        .headers({ 
          "Content-Type": "application/json",
          "Accept": "application/json"
        })
        .send();
}

export const fetchAllBackups = async function(workspaceId, keyword, typeFilters, page, limit) {
    const response = await new HttpRequestBuilder()
        .method('post')
        .url(URL_BACKUPS + workspaceId + URL_QUERY_SESSION_TOKEN)
        .headers({ 
          "Content-Type": "application/json",
          "Accept": "application/json"
        })
        .data({
            keyword: keyword,
            typeFilters: typeFilters,
            page: page,
            limit: limit
        })
        .send();

    return response.data;
}

export const createNewBackup = async function(workspaceId, backup) {
    const response = await new HttpRequestBuilder()
        .method('put')
        .url(URL_BACKUPS + workspaceId + URL_QUERY_SESSION_TOKEN)
        .headers({ 
          "Content-Type": "application/json",
          "Accept": "application/json"
        })
        .data(backup)
        .send();

    return response.data.id;
}

export const deleteBackup = async function(workspaceId, id) {
    await new HttpRequestBuilder()
        .method('delete')
        .url(URL_BACKUPS + workspaceId + "/" + id + URL_QUERY_SESSION_TOKEN)
        .send();
}

export const restoreBackup = async function(workspaceId, id) {
    const response = await new HttpRequestBuilder()
        .method('post')
        .url(URL_BACKUPS + workspaceId + "/" + id + URL_QUERY_SESSION_TOKEN)
        .send();

    return response.data;
}

export const fetchSettings = async function() {
    const response = await new HttpRequestBuilder()
        .method('get')
        .url(URL_SETTINGS + URL_QUERY_SESSION_TOKEN)
        .headers({ 
          "Content-Type": "application/json",
          "Accept": "application/json"
        })
        .send();

    return response.data;
}

export const saveSettings = async function(settings) {
    await new HttpRequestBuilder()
        .method('put')
        .url(URL_SETTINGS + URL_QUERY_SESSION_TOKEN)
        .headers({ 
          "Content-Type": "application/json",
          "Accept": "application/json"
        })
        .data(settings)
        .send();
}